"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("../helpers/prop-types");
var _propTypes2 = _interopRequireDefault(require("prop-types"));
var _venn = require("@upsetjs/venn.js");
var _colors = require("../helpers/colors");
var _reactVis = require("react-vis");
var _empty = require("./empty");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColors = (0, _colors.colorScaleCategorical)();
var circleOpacity = 0.4;
var VennChart = /*#__PURE__*/function (_Component) {
  _inherits(VennChart, _Component);
  var _super = _createSuper(VennChart);
  function VennChart() {
    var _this;
    _classCallCheck(this, VennChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      toolTipText: undefined,
      toolTipOpacity: 0,
      toolTipPos: null,
      overlapOffset: -20,
      hoveredPathId: null
    });
    return _this;
  }
  _createClass(VennChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        width = _this$props.width,
        height = _this$props.height,
        renderLegend = _this$props.renderLegend,
        showBoundingBoxes = _this$props.showBoundingBoxes;
      var graphData = this._processData();
      var labelsData = this._calculateLabels(graphData);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
        id: "textShadow"
      }, /*#__PURE__*/_react.default.createElement("feDropShadow", {
        dx: "0",
        dy: "0",
        stdDeviation: "1.5",
        floodColor: "#ecf0f1",
        floodOpacity: "1"
      }))), graphData.map(function (set, i) {
        return _this2._renderData(set, i);
      }), labelsData.map(function (label, i) {
        return _this2._renderLabels(label, i);
      }), !showBoundingBoxes ? undefined : labelsData.map(function (label, i) {
        return _this2._renderBoundingBoxes(label, i);
      })), this._renderToolTip(), renderLegend ? this._renderLegend(graphData) : undefined);
    }
  }, {
    key: "_renderLegend",
    value: function _renderLegend(graphData) {
      var _this3 = this;
      var keyColor = graphData.filter(function (x) {
        return x.circles.length == 1;
      }).map(function (set, i) {
        return {
          title: set.circles[0].set,
          color: defaultColors(i)
        };
      });
      return /*#__PURE__*/_react.default.createElement(_reactVis.DiscreteColorLegend, {
        orientation: "horizontal",
        items: keyColor,
        style: {
          cursor: "pointer",
          userSelect: "none"
        },
        onItemMouseLeave: function onItemMouseLeave() {
          return _this3._handleMouseOut();
        },
        onItemMouseEnter: function onItemMouseEnter(item) {
          var hoveredSet = graphData.find(function (x) {
            return x.circles.length == 1 && x.circles[0].set == item.title;
          });
          _this3._handleMouseOver(hoveredSet, graphData.indexOf(hoveredSet), false);
        }
      });
    }

    // Renders the tooltips
  }, {
    key: "_renderToolTip",
    value: function _renderToolTip() {
      var pos = this.state.toolTipPos;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "rv-hint__content",
        style: {
          position: "fixed",
          textAlign: "center",
          opacity: this.state.toolTipOpacity,
          pointerEvents: "none",
          top: pos ? pos.y : "0px",
          left: pos ? pos.x : "0px"
        }
      }, this.state.toolTipText ? this.state.toolTipText : "");
    }

    // Renders the data for this dataset
  }, {
    key: "_renderData",
    value: function _renderData(set, i) {
      var _this4 = this;
      var hoveredPathId = this.state.hoveredPathId;
      var hoverStrokeColor = this.props.hoverStrokeColor;
      return /*#__PURE__*/_react.default.createElement("g", {
        key: "paint-".concat(i),
        onMouseOver: function onMouseOver() {
          return _this4._handleMouseOver(set, i);
        },
        onMouseOut: function onMouseOut() {
          return _this4._handleMouseOut();
        },
        onMouseMove: function onMouseMove(e) {
          return _this4._handleMouseMove(e);
        }
      }, "(", /*#__PURE__*/_react.default.createElement("path", {
        d: set.path,
        stroke: hoveredPathId != null ? hoveredPathId == i ? hoverStrokeColor : "transparent" : "transparent",
        fill: "transparent",
        strokeWidth: "2"
      }), ")", this._renderCircle(set, i));
    }

    // Renders the circle only if it's a main one
  }, {
    key: "_renderCircle",
    value: function _renderCircle(set, i) {
      // If this only has one circle it means it's a main section
      if (set.circles.length === 1) {
        return /*#__PURE__*/_react.default.createElement("circle", {
          cx: set.circles[0].x,
          cy: set.circles[0].y,
          r: Math.abs(set.circles[0].radius),
          fill: defaultColors(i),
          style: {
            opacity: circleOpacity
          }
        });
      }
      return null;
    }

    // Renders the labels according to what should be shown
  }, {
    key: "_renderLabels",
    value: function _renderLabels(label, i) {
      var _this5 = this;
      var textGlow = this.props.textGlow;

      // If this label has an arrow pointing to it
      if (label.position.arrow) {
        return /*#__PURE__*/_react.default.createElement("g", {
          key: "labels-".concat(i),
          style: {
            userSelect: "none"
          },
          onMouseOver: function onMouseOver() {
            return _this5._handleMouseOver(label.set, i);
          },
          onMouseOut: function onMouseOut() {
            return _this5._handleMouseOut();
          },
          onMouseMove: function onMouseMove(e) {
            return _this5._handleMouseMove(e);
          }
        }, /*#__PURE__*/_react.default.createElement("line", {
          x1: label.position.x,
          y1: label.position.y,
          x2: label.boundingBox.x + label.boundingBox.width / 2,
          y2: label.boundingBox.y + label.boundingBox.height / 2,
          stroke: "gray",
          strokeWidth: "1",
          filter: textGlow ? "url(#textShadow)" : undefined
        }), /*#__PURE__*/_react.default.createElement("text", {
          x: label.boundingBox.x + 2,
          y: label.boundingBox.y + 17,
          textAnchor: "left",
          fill: label.data.percentColor,
          fontWeight: "bold",
          filter: textGlow ? "url(#textShadow)" : undefined
        }, label.data.percent, "%"));
      }
      return /*#__PURE__*/_react.default.createElement("g", {
        key: "labels-".concat(i),
        style: {
          userSelect: "none"
        },
        onMouseOver: function onMouseOver() {
          return _this5._handleMouseOver(label.set, i);
        },
        onMouseOut: function onMouseOut() {
          return _this5._handleMouseOut();
        },
        onMouseMove: function onMouseMove(e) {
          return _this5._handleMouseMove(e);
        }
      }, label.set.data.sets.length == 1 ? /*#__PURE__*/_react.default.createElement("text", {
        x: label.position.x,
        y: label.position.y,
        textAnchor: "middle",
        fill: label.data.labelColor,
        fontWeight: "bold",
        filter: textGlow ? "url(#textShadow)" : undefined
      }, label.set.data.sets[0]) : null, /*#__PURE__*/_react.default.createElement("text", {
        x: label.position.x,
        y: label.position.y + (label.set.data.sets.length == 1 ? 15 : 0),
        textAnchor: "middle",
        fill: label.data.percentColor,
        fontWeight: "bold",
        filter: textGlow ? "url(#textShadow)" : undefined
      }, label.data.percent, "%"));
    }
  }, {
    key: "_renderBoundingBoxes",
    value: function _renderBoundingBoxes(label, i) {
      return /*#__PURE__*/_react.default.createElement("g", {
        key: "box-".concat(i)
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: label.boundingBox.x,
        y: label.boundingBox.y,
        width: label.boundingBox.width,
        height: label.boundingBox.height,
        style: {
          fill: "transparent",
          stroke: "rgb(0,0,0)",
          strokeWidth: 1
        }
      }));
    }
  }, {
    key: "_calculateLabels",
    value: function _calculateLabels(graphData) {
      var _this6 = this;
      var showLineSmallLabels = this.props.showLineSmallLabels;
      var labelsData = [];
      var dataTotal = 0;
      var i = 0;
      var _iterator = _createForOfIteratorHelper(graphData),
        _step;
      try {
        var _loop = function _loop() {
          var set = _step.value;
          var area = (0, _venn.intersectionArea)(set.circles);
          var labelData = {
            data: {
              percent: null,
              labelColor: _this6.props.labelColor ? _this6.props.labelColor : defaultColors(i),
              percentColor: _this6.props.percentColor ? _this6.props.percentColor : defaultColors(i)
            },
            position: {
              x: set.text.x,
              y: set.text.y,
              arrow: false
            },
            boundingBox: {
              x: set.text.x - (set.data.sets.length == 1 ? 80 : 30),
              y: set.text.y - (set.data.sets.length == 1 ? 16 : 10),
              width: set.data.sets.length == 1 ? 160 : 60,
              height: set.data.sets.length == 1 ? 32 : 20
            },
            set: set
          };

          // Check if this is a combination area
          if (set.circles.length !== 1) {
            // Find the colors of the circles under this label
            var underCircles = set.circles.map(function (circle) {
              var i = graphData.indexOf(graphData.find(function (dataSet) {
                return dataSet.circles.length === 1 && dataSet.circles[0].set == circle.set;
              }));
              return {
                i: i,
                color: defaultColors(i)
              };
            }).sort(function (a, b) {
              return a.i - b.i;
            }).map(function (x) {
              return x.color;
            });
            labelData.data.percentColor = _this6._calculateColor(underCircles);
          }

          // If the area is larger then draw the full labels
          if (area >= 3600 || !showLineSmallLabels) {
            // If this has an overlapping box with the same data number
            if (labelsData.find(function (x) {
              return _this6._checkBoxesOverlap(labelData.boundingBox, x.boundingBox) && labelData.set.data.size == x.set.data.size;
            })) {
              // Don't draw this label
              return "continue";
            }

            // Find the best bounding box for this label
            labelData.boundingBox = _this6._findLabelDistance(labelData.boundingBox, labelsData);

            // Recalculate the position
            labelData.position.x = labelData.boundingBox.x + labelData.boundingBox.width / 2;
            labelData.position.y = labelData.boundingBox.y + labelData.boundingBox.height / 2;
          } else {
            // If this area is too small and should have an arrow

            var labelBox = _this6._findLabelAngle(0, labelData.position.x, labelData.position.y, labelsData);

            // Label could not be created
            if (!labelBox) {
              return "continue";
            }
            labelData.position.arrow = true;
            labelData.boundingBox = labelBox;
          }
          labelsData.push(labelData);
          i++;
          dataTotal += set.data.size;
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();
          if (_ret === "continue") continue;
        }

        // map the new percentage
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      labelsData.map(function (x) {
        // Calculate the percentage to show
        x.data.percent = Math.round(x.set.data.size / dataTotal * 10000) / 100;
        if (x.data.percent == 0) {
          x.data.percent = Math.round(x.set.data.size / dataTotal * 100000) / 1000 > 0 ? Math.round(x.set.data.size / dataTotal * 100000) / 1000 : 0;
        }
        return x;
      });
      return labelsData;
    }

    // Process the data before showing the graph
  }, {
    key: "_processData",
    value: function _processData() {
      var _this$props2 = this.props,
        width = _this$props2.width,
        height = _this$props2.height,
        data = _this$props2.data,
        padding = _this$props2.padding,
        filterToLargestSet = _this$props2.filterToLargestSet,
        isLogRatioLossFunc = _this$props2.isLogRatioLossFunc;

      // Process the data pre-charting
      var processedData = [];
      var _iterator2 = _createForOfIteratorHelper(data),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var set = _step2.value;
          processedData.push({
            sets: set.k.split("___"),
            size: set.v
          });
        }

        // Create the layout using upset/venn.js
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var chartData = (0, _venn.layout)(processedData, {
        width: width,
        height: height,
        padding: padding,
        lossFunction: isLogRatioLossFunc ? _venn.logRatioLossFunction : _venn.lossFunction
      });

      // Sort based on how many circles so the main sections are first
      chartData.sort(function (a, b) {
        if (a.circles.length > b.circles.length) return 1;
        if (a.circles.length < b.circles.length) return -1;
        return 0;
      });
      var filteredData = chartData.filter(function (x) {
        // if it only has 1 set
        if (x.data.sets.length == 1) return true;

        // If it has any other sets with the exact same number
        var matchingSizeList = chartData.filter(function (y) {
          return y.data.size == x.data.size;
        });

        // No matching sets
        if (matchingSizeList.length == 1) return true;

        // Sort by number of sets in the match
        matchingSizeList.sort(function (a, b) {
          if (a.data.sets.length < b.data.sets.length) return 1;
          if (a.data.sets.length > b.data.sets.length) return -1;
          return 0;
        });

        // Grab the highest ordered one
        // Check if it has more
        if (matchingSizeList[0].data.sets.length <= x.data.sets.length) return true;

        // Check if the largest contains all these
        var _iterator3 = _createForOfIteratorHelper(x.data.sets),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var set = _step3.value;
            if (!matchingSizeList[0].data.sets.includes(set)) return true;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
      return filterToLargestSet ? filteredData : chartData;
    }
  }, {
    key: "_handleMouseOver",
    value: function _handleMouseOver(set, i) {
      var showToolTip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // Build the text for the tooltip
      var toolTipText = /*#__PURE__*/_react.default.createElement("div", null, set.data.sets.map(function (a, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: i
        }, a);
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontWeight: "bolder"
        }
      }, set.data.size.toLocaleString())));

      // Set the state for the text and opacity 
      this.setState({
        toolTipText: toolTipText,
        toolTipOpacity: showToolTip ? 0.9 : 0.0,
        hoveredPathId: i
      });
    }
  }, {
    key: "_handleMouseOut",
    value: function _handleMouseOut() {
      this.setState({
        toolTipText: undefined,
        toolTipOpacity: 0,
        hoveredPathId: null,
        toolTipPos: null
      });
    }
  }, {
    key: "_handleMouseMove",
    value: function _handleMouseMove(e) {
      this.setState({
        toolTipPos: {
          x: e.clientX + 15,
          y: e.clientY - 28
        }
      });
    }
  }, {
    key: "_calculateColor",
    value: function _calculateColor(colorData) {
      // Split the hex colours to rgba
      var rgba = [];
      var _iterator4 = _createForOfIteratorHelper(colorData),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var color = _step4.value;
          var split = color.replace("#", "").match(/([a-fA-F\d]{2})/gm);
          rgba.push({
            r: parseInt(split[0], 16),
            g: parseInt(split[1], 16),
            b: parseInt(split[2], 16),
            a: circleOpacity
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var outputColor = {
        r: colorFormula(rgba[0].r, 255, circleOpacity * 2),
        g: colorFormula(rgba[0].g, 255, circleOpacity * 2),
        b: colorFormula(rgba[0].b, 255, circleOpacity * 2),
        a: circleOpacity * 2
      };
      for (var i = 1; i < rgba.length; i++) {
        outputColor = {
          r: colorFormula(rgba[i].r, outputColor.r, outputColor.a),
          g: colorFormula(rgba[i].g, outputColor.g, outputColor.a),
          b: colorFormula(rgba[i].b, outputColor.b, outputColor.a),
          a: alphaFormula(circleOpacity, outputColor.a)
        };
      }
      return "rgb(".concat(outputColor.r, ",").concat(outputColor.g, ",").concat(outputColor.b, ")");
      function colorFormula(top, bottom, alpha) {
        return (1 - alpha) * bottom + alpha * top;
      }
      function alphaFormula(top, bottom) {
        return 1 - (1 - bottom) * (1 - top);
      }
    }
  }, {
    key: "_findLabelDistance",
    value: function _findLabelDistance(boundingBox, labelsData) {
      var _this7 = this;
      var distances = [];

      // Loop through all 4 directions
      for (var i = 0; i < 4; i++) {
        var _loop2 = function _loop2() {
          // Calculate the new position of the box
          var newPos = _objectSpread(_objectSpread({}, boundingBox), {}, {
            y: i == 0 ? boundingBox.y + distance : i == 1 ? boundingBox.y - distance : boundingBox.y,
            x: i == 2 ? boundingBox.x + distance : i == 3 ? boundingBox.x - distance : boundingBox.x
          });
          // if this box doesn't overlap with anything
          if (!labelsData.find(function (x) {
            return _this7._checkBoxesOverlap(x.boundingBox, newPos);
          })) {
            // If the distance is 0 we don't need to move
            if (distance == 0) return {
              v: newPos
            };
            distances.push({
              distance: distance,
              newPos: newPos
            });
            return "break";
          }
        };
        // Find a distance that works
        for (var distance = 0; distance < 100; distance += 10) {
          var _ret2 = _loop2();
          if (_ret2 === "break") break;
          if (_typeof(_ret2) === "object") return _ret2.v;
        }
      }

      // return the position with the shortest distance
      return distances.reduce(function (prev, curr) {
        return prev.distance < curr.distance ? prev : curr;
      }).newPos;
    }
  }, {
    key: "_checkBoxesOverlap",
    value: function _checkBoxesOverlap(box1, box2) {
      var buffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      return box1.x + buffer < box2.x + box2.width && box1.x + buffer + box1.width > box2.x && box1.y + buffer < box2.y + box2.height && box1.y + buffer + box1.height > box2.y;
    }
  }, {
    key: "_findLabelAngle",
    value: function _findLabelAngle(angle, x, y, labelsData) {
      var labelLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.props.smallLabelLineLength;
      // Calculate the new coordinates of this box
      var nx = x + labelLength * Math.cos(angle * (Math.PI / 180));
      var ny = y + labelLength * Math.sin(angle * (Math.PI / 180));
      var width = 50;
      var height = 25;

      // If there is no good place for this label
      if (angle >= 360) {
        return this._findLabelAngle(0, x, y, labelsData, labelLength + 20);
      }
      if (labelLength > this.props.smallLabelLineLength * 10) {
        return null;
      }

      // Check if this is inside any box
      var _iterator5 = _createForOfIteratorHelper(labelsData),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var boundingBox = _step5.value.boundingBox;
          if (this._checkBoxesOverlap(boundingBox, {
            x: nx,
            y: ny,
            width: width,
            height: height
          })) {
            return this._findLabelAngle(angle + 20, x, y, labelsData, labelLength);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return {
        x: nx,
        y: ny,
        width: width,
        height: height
      };
    }
  }]);
  return VennChart;
}(_react.Component);
_defineProperty(VennChart, "propTypes", {
  width: _propTypes2.default.number,
  // Width of the SVG
  height: _propTypes2.default.number,
  // Height of the SVG
  data: _propTypes.propTypeVennData.isRequired,
  // [{k,v}] data to display
  padding: _propTypes2.default.number,
  // Padding inside the SVG for labels
  hoverStrokeColor: _propTypes2.default.string,
  // Circle stroke on mouse hover events
  labelColor: _propTypes2.default.string,
  // Color of text labels (defaults to section color)
  percentColor: _propTypes2.default.string,
  // Color of percentages (defaults to section color)
  showLineSmallLabels: _propTypes2.default.bool,
  // Should smaller areas be represented by an arrow to the percentage
  smallLabelLineLength: _propTypes2.default.number,
  // How long should the above arrow be
  textGlow: _propTypes2.default.bool,
  // Should text have a white glow for readability
  renderLegend: _propTypes2.default.bool,
  // Should a legend be rendered
  filterToLargestSet: _propTypes2.default.bool,
  // Should sets with the same numbers be reduced to the largest set
  showBoundingBoxes: _propTypes2.default.bool,
  // Should we show the bounding boxing for text in the chart
  isLogRatioLossFunc: _propTypes2.default.bool // Should we use the new formula for log ratio in the loss function
});
_defineProperty(VennChart, "defaultProps", {
  width: 600,
  height: 600,
  hoverStrokeColor: "#000000",
  labelColor: null,
  percentColor: null,
  showLineSmallLabels: true,
  padding: 30,
  smallLabelLineLength: 50,
  textGlow: true,
  renderLegend: true,
  filterToLargestSet: true,
  showBoundingBoxes: false,
  isLogRatioLossFunc: true
});
var _default = (0, _empty.withEmptyView)(VennChart);
exports.default = _default;